import { useSelector } from 'react-redux'
import { path } from 'ramda'
import PageTitle from '@/components/page-title'
import useCurrentSession from '@/hooks/use-current-session'
import Documents from './tenancy-documents'
import RenterDocuments from './renter-tenancy-documents'

const ContractManager = ({
  match: {
    params: { contractId }
  }
}) => {
  const session = useCurrentSession()
  const operationType = session.operation_type
  const contract = useSelector(path(['contract', contractId, 'contract']))
  const components = {
    tenant: <RenterDocuments contractId={contractId} />,
    landlord: <Documents contractId={contractId} />
  }

  const { [operationType]: component = <Documents contractId={contractId} /> } = components

  const listingAddress = `${
    contract?.units.unit_number ? `${contract?.units.unit_number} - ` : ''
  } ${contract?.buildings?.full_address}`

  return (
    <>
      <PageTitle to={`/listing/${contract?.listing_id}`}>{listingAddress}</PageTitle>
      {component}
    </>
  )
}

export default ContractManager
